export default __webpack_public_path__ + "static/media/maintenance.7437fb0d.png";